export enum ReportDetailEnum {
    financial,
    consumption,
    consumptionDetailed
}
